import Vue from 'vue'
import config from '../../../static/config.json'
const moment = require('moment')

Vue.mixin({
  data() {
    return {
      title_web: config.title_web,
      description_web: config.description_web,
      last_update: config.last_update
    }
  },
  methods: {
    dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/js/mixin.js